import React, { useEffect, useState } from 'react';
import './ProductHeader.css';

const ProductHeader = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsVisible(true);
  }, []);

  const sectionStyle = {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
    transition: 'opacity 0.8s ease-out, transform 0.8s ease-out',
  };

  return (
    <div className="product-experience-section" style={sectionStyle}>
      <div className="overlay"></div>

      <div className="content-wrapper">
        <div className="text-content">
          <h1>Precision-Engineered Metal Components for Every Industry</h1>
          <p>
          Explore our wide range of high-quality metal components, designed for durability and precision. From standard to custom-made parts, Akinex delivers innovative solutions to meet your industry’s unique needs. Crafted with excellence, built to last.
          </p>
        </div>
        <div className="search-bar">
        <div className="arrow">&#x25BC;</div>
        </div>
      </div>
    </div>
  );
};

export default ProductHeader;